import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  CreateCategoryDTO,
  MasterApiService,
} from 'features/master-management/api/master-api.service';

import { MasterQueryKeys } from './query-keys';

const { createCategory } = MasterApiService();

export const useCreateCategory = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: CreateCategoryDTO) => {
      return createCategory(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: MasterQueryKeys.lists(),
        });
      },
    },
  );
};
